export default "__VITE_ASSET__DvEplBk8__"